import {useState} from "react";
import {message} from "antd";
import Swal from "sweetalert2";

import {ContactEditRequest, ContactListResponse} from "~/data/board/contact/use-contact.interface";
import {httpRequest} from "~/fetch/common/http-request";

const useContactList = (config: {keyword: string; page: number; category: string | null}) => {
    const [response, setResponse] = useState<ContactListResponse | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const request = async () => {
        setLoading(true);
        return await httpRequest<{keyword: string; page: number; category: string | null}, ContactListResponse>({
            method: "GET",
            url: "/commonBoard/contact/list",
            params: {
                page: Number(config.page),
                keyword: config.keyword || null,
                category: config.category,
            },
        })
            .submit()
            .then((res) => setResponse(res.data))
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    };

    return {data: response, submit: request, loading};
};

const useContactHandler = (config: ContactEditRequest) => {
    const [loading, setLoading] = useState<boolean>(false);

    const register = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("data", JSON.stringify({...config}));
        return await httpRequest<FormData, null>({
            method: "POST",
            url: "/commonBoard/contact",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        })
            .submit()
            .then((res) => {
                message.config({top: 100});
                message.success("등록되었습니다.");
            })
            .catch((err) => {
                Swal.fire({
                    text: "오류가 발생하였습니다. 다시 시도해주세요",
                    confirmButtonText: "확인",
                });
                console.error(err);
            })
            .finally(() => setLoading(false));
    };

    const update = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("data", JSON.stringify({...config}));
        return await httpRequest<FormData, null>({
            method: "POST",
            url: "/commonBoard/contact/update",
            headers: {
                "Content-Type": "multipart/form-data",
            },
            data: formData,
        })
            .submit()
            .then(() => {
                message.config({top: 100});
                message.success("수정되었습니다.");
            })
            .catch((err) =>
                Swal.fire({
                    text: "오류가 발생하였습니다. 다시 시도해주세요",
                    confirmButtonText: "확인",
                }),
            )
            .finally(() => setLoading(false));
    };

    const deleteContact = async (id: number) => {
        setLoading(true);
        return await httpRequest<{id: number}, null>({
            method: "DELETE",
            url: `/commonBoard/contact/${id}`,
        })
            .submit()
            .then(() => {
                message.config({top: 100});
                message.success("삭제되었습니다.");
            })
            .finally(() => setLoading(false));
    };

    return {register, update, deleteContact, loading};
};

export {useContactHandler, useContactList};
